import React from 'react';

import Spacings from '~/modules/ui-kit/spacings';

import { Box, Typography } from '@mui/material';

type InformationalSectionProps = {
  title: React.ReactNode;
  children: React.ReactNode;
};

const InformationalSection = (props: InformationalSectionProps) => {
  return (
    <div>
      <Spacings.Inline>
        <Box sx={{ px: 2, py: 1 }}>
          <Typography
            variant="h6"
            style={{ flexGrow: 1 }}
            color="textSecondary"
          >
            {props.title}
          </Typography>
        </Box>
      </Spacings.Inline>
      {props.children}
    </div>
  );
};

export default InformationalSection;
